import type { LucideIcon } from "lucide-react";
import { MetricHelp } from "../metric-help";

type DashboardKpiTone =
  | "blue"
  | "emerald"
  | "amber"
  | "rose"
  | "cyan"
  | "violet";

type DashboardKpiCardProps = {
  icon: LucideIcon;
  tone: DashboardKpiTone;
  value: string | number;
  label: string;
  helpText?: string;
  helpLabel?: string;
  description?: string;
};

const ICON_TONE_CLASS: Record<DashboardKpiTone, string> = {
  blue: "dashboard-stat-icon-blue",
  emerald: "dashboard-stat-icon-emerald",
  amber: "dashboard-stat-icon-amber",
  rose: "dashboard-stat-icon-rose",
  cyan: "dashboard-stat-icon-cyan",
  violet: "dashboard-stat-icon-violet",
};

export function DashboardKpiCard({
  icon: Icon,
  tone,
  value,
  label,
  helpText,
  helpLabel,
  description,
}: DashboardKpiCardProps) {
  return (
    <article className="dashboard-stat-card">
      <div className={`dashboard-stat-icon ${ICON_TONE_CLASS[tone]}`}>
        <Icon className="h-5 w-5 text-white" />
      </div>

      <div className="min-w-0">
        <p className="dashboard-stat-value">{value}</p>
        <p className="dashboard-stat-label">
          <span>{label}</span>
          <MetricHelp helpText={helpText} label={helpLabel} className="ml-1" />
        </p>
        {description ? (
          <p className="dashboard-stat-description">{description}</p>
        ) : null}
      </div>
    </article>
  );
}
